module.exports = __webpack_public_path__ + "img/ZW.31a10d63.svg";